import { documentItemFromDocument } from './documentItemMapper'

/** Map a do-chat-api document row (DocumentOut) to the UI shape. */
export function documentFromRow(row = {}) {
  const metadata = row.metadata ?? {}
  const doc = {
    id: String(row.id ?? ''),
    name: String(row.original_file_name || 'Untitled'),
    status: String(row.status || 'uploaded'),
    pipeline: row.pipeline ?? null,
    sourceFormat: row.source_format ?? null,
    pageCount: row.page_count ?? null,
    sheets: Array.isArray(metadata.sheets) ? metadata.sheets : [],
    summary: metadata.summary ?? '',
    error: row.error ?? null,
    updatedAt: row.updated_at ?? row.created_at ?? null,
  }
  // documentItemFromDocument replaces `updatedAt` with a display string, so the
  // sortable value is kept alongside it (the Recent row orders on this).
  const updatedAtMs = Date.parse(String(doc.updatedAt ?? ''))
  return {
    ...doc,
    ...documentItemFromDocument(doc),
    updatedAtMs: Number.isFinite(updatedAtMs) ? updatedAtMs : 0,
  }
}

/**
 * Whether parsing is actually running for this document.
 *
 * `uploaded` is not processing: the file is saved and nothing is scheduled
 * until an explicit prepare. Counting it here made every caller wait on — and
 * poll for — a transition that only a submitted question can trigger.
 */
export function isProcessing(doc) {
  return doc?.status === 'processing'
}
